import { render } from "./AccountDelete.vue?vue&type=template&id=e9aa8cf8"
import script from "./AccountDelete.vue?vue&type=script&lang=js"
export * from "./AccountDelete.vue?vue&type=script&lang=js"

import exportComponent from "/home/aloco/alocohawaii.com/moa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__